// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"WhatsNewAlert_buttonWrapper__FLUXE"};